import { useRef } from 'react';
import XTable from 'components/XTable';
import { getReadNoticeRecordApi } from '../../api/readNoticeRecord';

const ReadNoticeRecord = () => {
    const xTableRef = useRef();

    const columns = [
        {
            title: '序号',
            dataIndex: 'id',
        },
        {
            title: '登录ip',
            dataIndex: 'ip',
        },
        {
            title: '登录时间',
            dataIndex: 'loginTime',
        },
        {
            title: '登录身份',
            dataIndex: 'idNo',
        },
        {
            title: '阅读标记',
            dataIndex: 'readMark',
        },
        {
            title: '阅读时长(秒)',
            dataIndex: 'readTime',
            render: val => val / 1000,
        },
    ];

    const queryItems = [];

    return (
        <div>
            <XTable
                columns={columns}
                queryItems={queryItems}
                api={getReadNoticeRecordApi}
                rowKey="id"
                ref={xTableRef}
            />
        </div>
    );
};
export default ReadNoticeRecord;
